/**
 * Parse «quoted» phrases from tailoring feedback and check summary text (PS5/PS8 parity).
 */

export function extractGuillemetPhrases(text: string): string[] {
  const phrases: string[] = []
  for (const match of text.matchAll(/«([^»]+)»/g)) {
    const phrase = match[1]?.trim()
    if (phrase) phrases.push(phrase)
  }
  return phrases
}

export function recommendationUsesOrAlternatives(recommendation: string): boolean {
  return /\bor\s+«/.test(recommendation)
}

export function summaryContainsRequiredPhrase(summary: string, phrase: string): boolean {
  const hay = summary.toLowerCase().replace(/\s+/g, ' ').trim()
  const needle = phrase.toLowerCase().replace(/\s+/g, ' ').trim()
  if (!needle) return false
  if (!needle.includes(' ')) {
    const escaped = needle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    return new RegExp(`\\b${escaped}\\b`, 'i').test(summary)
  }
  return hay.includes(needle)
}

export function summarySatisfiesPhraseRequirement(
  summary: string,
  phrases: string[],
  recommendation: string
): boolean {
  if (!phrases.length || !summary.trim()) return false
  if (recommendationUsesOrAlternatives(recommendation)) {
    return phrases.some((phrase) => summaryContainsRequiredPhrase(summary, phrase))
  }
  return phrases.every((phrase) => summaryContainsRequiredPhrase(summary, phrase))
}

export function summarySatisfiesRecommendation(recommendation: string, summary: string): boolean {
  const phrases = extractGuillemetPhrases(recommendation)
  if (!phrases.length) return false
  return summarySatisfiesPhraseRequirement(summary, phrases, recommendation)
}

/** Mirror API `_ai_focus_hits` for PS5 when feedback has no guillemets. */
export function summaryHasAiFocusSignals(summary: string): boolean {
  return /\b(llm|agentic|generative ai|genai|workflow automation|automation|ai product|machine learning|langchain|rag)\b/i.test(
    summary
  )
}
